import React from "react";
import TeamTitle from "../../components/title/TeamTitle";
import { CardBody, CardContainer, CardFooter, CardHeader } from "best-common-react";
import AdminProtected from "../../components/protected/AdminProtected";
import ParkingPassBody from "../../components/request/parking/ParkingPassBody";
import ParkingPassFooter from "../../components/request/parking/ParkingPassFooter";

function ParkingRequestContainer(props) {
  return (
    <div>
      <TeamTitle disabled={true} />
      <CardContainer>
        <CardHeader>Request Parking Passes</CardHeader>
        <CardBody>
          <ParkingPassBody gamePK={props.match.params.gamePK} />
        </CardBody>
        <CardFooter>
          <ParkingPassFooter />
        </CardFooter>
      </CardContainer>
    </div>
  );
}

export default AdminProtected(ParkingRequestContainer);
